module.exports = __webpack_public_path__ + "media/images/user_icon-cb670d4df94de64b6df1ac4d3ae2789c.jpg";